/**
 * @generated SignedSource<<15a36ab2bc57b392888942a634a35703>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type card_workManagementBoard_queryFragment$data = {
  readonly " $fragmentSpreads": FragmentRefs<"card_workManagementBoard_CardCoverWrapper_queryFragment">;
  readonly " $fragmentType": "card_workManagementBoard_queryFragment";
};
export type card_workManagementBoard_queryFragment$key = {
  readonly " $data"?: card_workManagementBoard_queryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"card_workManagementBoard_queryFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "card_workManagementBoard_queryFragment",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "card_workManagementBoard_CardCoverWrapper_queryFragment"
    }
  ],
  "type": "Query"
};

(node as any).hash = "212a8dda01f4f4efb58741c384172fab";

export default node;
